import { getRequest } from "../../../utils/requests";
import config from "../../../config.json";
import { message } from "antd";

// Получить статистику NPS за сегодня
export const fetchNpsToday = async () => {
  try {
    const url = `${config.service}/api/nps/summary/today`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить статистику за сегодня");
    throw error;
  }
};

// Получить статистику NPS за вчера
export const fetchNpsYesterday = async () => {
  try {
    const url = `${config.service}/api/nps/summary/yesterday`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить статистику за вчера");
    throw error;
  }
};

// Получить статистику NPS по дням недели
export const fetchNpsByWeekdays = async () => {
  try {
    const url = `${config.service}/api/nps/summary/by-weekdays`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить статистику по дням недели");
    throw error;
  }
};

// Получить статистику NPS за период
export const fetchNpsByDateRange = async (from, to) => {
  try {
    const url = `${config.service}/api/nps/summary/by-date-range?from=${from}&to=${to}`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить статистику за период");
    throw error;
  }
};

// Получить последние NPS оценки
export const fetchLastNps = async (limit = 100) => {
  try {
    const url = `${config.service}/api/nps/last?limit=${limit}`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить последние оценки");
    throw error;
  }
};

// Получить информацию о клиенте (для модального окна с деталями)
export const fetchClient = async (id) => {
  try {
    const url = `${config.service}/api/client/${id}`;
    const response = await getRequest(url, {});
    return response.data;
  } catch (error) {
    message.error("Не удалось загрузить информацию о клиенте");
    throw error;
  }
};
